import { Heading } from '@boltenergy-be/design-system'

const TermsFrench = () => {
  return (
    <>
      <Heading as="h2" variant="h3">
        Conditions générales pour la fourniture d’électricité et/ou de gaz naturel par Bolt Energie SRL (ci-après « nous ») au client
        (ci-après « vous ») et la restitution d’électricité _ 01-02-21
      </Heading>
      <h3>1. Les définitions et applications des Conditions générales (ci-après « CG »)</h3>
      <p>
        <strong>Conditions particulières</strong> : notre document dans lequel le prix, la durée et les dispositions particulières du
        Contrat de fourniture et/ou du Contrat de restitution sont mentionnés (ci-après « CP »).
        <br />
        <strong>Consommateur</strong> : toute personne physique qui achète de l’électricité et/ou de gaz naturel à des fins qui n’entrent
        pas dans le cadre de son activité commerciale, industrielle, artisanale ou professionnelle, sauf disposition contraire de la
        réglementation applicable.
        <br />
        <strong>Petit consommateur professionnel</strong> : toute personne physique ou morale qui achète de l’électricité et/ou du gaz
        naturel partiellement ou exclusivement à des fins professionnelles, et dont la consommation annuelle pour l’ensemble de ses Points
        de fourniture est inférieure à 50 MWh d’électricité et à 100 MWh de gaz naturel pour les contrats conclus, modifiés ou renouvelés
        avant le 1er septembre 2021, et inférieure à 100 MWh d’électricité et/ou à 100 MWh de gaz naturel pour les contrats conclus,
        modifiés ou renouvelés à partir du 1er septembre 2021.
        <br />
        <strong>Fourniture</strong> : la fourniture au Point de fourniture d’électricité et/ou de gaz naturel.
        <br />
        <strong>Contrat de fourniture</strong> : l’ensemble du contrat entre vous et nous concernant la Fourniture : les CG, les CP ainsi
        que tout complément ou adaptation de ceux-ci par écrit font partie de ce Contrat de fourniture ; en cas de contradiction, les CP ont
        la priorité.
        <br />
        <strong>Point de fourniture</strong> : le point convenu où nous fournissons l’électricité et/ou le gaz naturel et où vous restituez
        le cas échéant l’électricité à Bolt ; ce point à un numéro EAN unique.
        <br />
        <strong>Gestionnaire de réseau</strong> : le gestionnaire du réseau national, régional ou local de transmission, de transport ou de
        distribution de l’électricité et/ou du gaz naturel.
        <br />
        <strong>Tarifs du réseau</strong> : les tarifs pour l’utilisation du réseau de distribution, de transmission ou de transport
        d’électricité et/ou de gaz.
        <br />
        <strong>Producteur d'électricité</strong> : le producteur d’électricité verte et locale proposé par Bolt et choisi par vous.
        <br />
        <strong>Restitution</strong> : la vente à Bolt d’électricité produite par le client et injectée au Point de fourniture.
        <br />
        <strong>Contrat de restitution</strong> : ll’ensemble du contrat entre vous et nous concernant la Restitution : les CG, les CP ainsi
        que tout complément ou adaptation de ceux-ci par écrit font partie de ce Contrat de fourniture et/ou de restitution ; en cas de
        contradiction, les CP ont la priorité.
        <br />
        <strong>Frais de restitution</strong> : la compensation payée par Bolt au client pour l’électricité produite par lui et injectée au
        Point de fourniture.
      </p>
      <p>
        Les termes qui ne sont pas définis dans le présent Contrat de fourniture et/ou le Contrat de restitution ont la signification telle
        que déterminée dans la législation en vigueur (en ce compris, les règlements techniques). Pour plus d'explication sur les
        législations régionales, nous référons aux sites Web des régulateurs compétents.
      </p>
      <p>
        Les présentes CG sont d'application à la fourniture d'électricité et de gaz naturel aux Consommateurs et aux Petits consommateurs
        professionnels. En signant le Contrat de fourniture, vous acceptez les présentes CG.
      </p>
      <h3>2. Contrat de fourniture</h3>
      <p>
        2.1. Nous fournirons l'électricité et/ou le gaz naturel tel que déterminé dans le Contrat de fourniture. Vous prélèverez notre
        électricité et/ou gaz naturel au Point de fourniture, vous nous payerez le prix convenu et vous respecterez les autres dispositions
        du Contrat de fourniture. Le Contrat de fourniture ne porte pas préjudice aux dispositions légales portant, entre autres, sur les
        missions de service public.
      </p>
      <p>
        2.2. Si nous ne disposons pas d'une quantité suffisante d'énergie durable issue de sources renouvelables en raison d'un cadre
        réglementaire modifié ou d'autres circonstances qui sont hors de notre contrôle, nous pouvons compléter la fourniture avec d'autres
        énergies toutefois aussi durables que possible.
      </p>
      <h3>3. Contrat de restitution</h3>
      <p>
        3.1. Vous ne pouvez conclure un Contrat de restitution avec Bolt que si vous avez également un Contrat de fourniture avec Bolt et
        que vous disposez d’un compteur digital au Point de fourniture. Un compteur digital mesure séparément votre achat et votre injection
        d’électricité, et peut être relevé à distance.
      </p>
      <p>
        3.2. Si nous concluons un Contrat de restitution, Bolt vous paiera un montant pour l’électricité que vous produisez et injectez au
        Point de fourniture. Ce montant est déterminé dans les CP.
      </p>
      <h3>4. Conclusion du Contrat de fourniture et/ou du Contrat de restitution</h3>
      <p>
        4.1. Le Contrat de fourniture et/ou le Contrat de restitution est élaboré dès que vous avez accepté notre offre et sous la condition
        suspensive de confirmation, par le gestionnaire de réseau, de vos coordonnées.
      </p>
      <p>
        4.2. Si le Contrat de fourniture et/ou le Contrat de restitution avec vous est conclu à distance (p.ex. via notre site Web ou par
        téléphone) ou en dehors des locaux de vente de notre entreprise (p.ex. sur des événements, via le porte-à-porte) et que vous êtes
        Consommateur, le Contrat de fourniture vous sera confirmé par écrit (par courrier ou par mail).
      </p>
      <p>
        4.3. Dans la mesure autorisée et conformément à la législation en vigueur, nous pouvons vous refuser en tant que client si nous
        avons des raisons objectives de douter de votre solvabilité. En outre, nous avons le droit, dans la mesure autorisée et conformément
        à la législation en vigueur, de vous demander une garantie dans les cas suivants :
      </p>
      <ol type="a">
        <li>vous avez un arriéré de dettes chez nous (auquel cas vous devez d'abord vous acquitter de ces dettes) ; et/ou</li>
        <li>
          vous n'avez pas, au cours de la période de 24 mois précédant la conclusion du Contrat de fourniture ou pendant la durée du Contrat
          de fourniture, payé deux ou plusieurs factures dans les délais.
        </li>
      </ol>
      <p>
        Si vous ne donnez pas suite à la demande de garantie dans un délai de 15 jours calendrier, nous pouvons également vous refuser comme
        client.
      </p>
      <p>
        La garantie correspondra au maximum à 3 mois de consommation estimée et nous pourrons l'utiliser pour le remboursement de vos
        dettes. Après remboursement éventuel des montants impayés, conformément à la législation en vigueur, la garantie sera reversée dans
        les 30 jours calendrier suivant notre facture de clôture. Dans tous les cas, vous pouvez demander la restitution de la garantie dès
        que vous avez payé toutes vos factures dans les délais, sans rappel de paiement pendant une période d’un an et dès que vous n’avez
        plus de dettes à notre égard, sauf indication contraire dans la loi.
      </p>
      <p>
        4.4. La Fourniture et/ou la Restitution commence dès que nous avons été enregistrés par le Gestionnaire du réseau comme fournisseur
        pour le Point de fourniture et/ou, en cas de Restitution, comme acheteur de l’électricité injectée par le client au Point de
        fourniture dans le registre de raccordement ou le registre d’accès. Si vous êtes Consommateur et que le Contrat de fourniture et/ou
        de restitution a été conclu à distance ou en dehors des locaux de vente de notre entreprise ou de nos partenaires, la Fourniture
        et/ou la Restitution débutera au plus tôt après le délai de rétractation, sauf si vous nous demandez expressément de déjà commencer
        la fourniture d'électricité et/ou de gaz naturel pendant le délai de rétractation prévu à l'article 5.1.
      </p>
      <p>
        4.5. Les Consommateurs qui sont encore liés par un Contrat de fourniture et/ou un Contrat de restitution ayant trait au Point de
        fourniture avec un autre fournisseur au moment de la conclusion du Contrat de fourniture et/ou de restitution nous donnent mandat
        exprès de résilier ce contrat de fourniture en leur nom et pour leur compte. Les clients qui sont encore liés par un contrat de
        restitution avec une autre partie que le fournisseur (comme un agrégateur) font le nécessaire pour résilier ce contrat et en fournir
        la preuve à Bolt.
      </p>
      <h3>5. Droit de rétractation</h3>
      <p>
        5.1. Si vous êtes un Consommateur, vous avez le droit de renoncer au présent Contrat de fourniture et/ou de restitution, sans
        paiement d’une amende et sans mention de motif, et ce, dans un délai de rétractation expirant 14 jours calendrier à partir de la
        réception de la confirmation du Contrat de fourniture et/ou de restitution par Bolt, ou si le Contrat de fourniture et/ou de
        restitution a été conclu par téléphone, à compter de la date de confirmation du Contrat de fourniture et/ou de restitution par
        vous-même. Pour exercer ce droit de rétractation, vous devez informer Bolt de cette décision au moyen d’une déclaration claire
        (p.ex., par courrier, fax ou e-mail). Vous pouvez pour cela utiliser le modèle de formulaire de rétractation annexé aux présentes CG
        et que vous pouvez également télécharger sur notre site Web www.boltenergie.be.
      </p>
      <p>
        5.2. Si vous avez demandé le lancement de la fourniture d’électricité et/ou de gaz naturel pendant le délai de rétractation, vous
        payez une somme proportionnelle au volume fourni au moment où vous nous notifiez votre rétractation du Contrat de fourniture. Si
        vous avez choisi de faire commencer votre Contrat de restitution pendant la période de rétractation, Bolt vous paiera une redevance
        pour l’électricité que vous avez injectée au Point de fourniture à partir de la date de début du Contrat de restitution jusqu’au
        moment où vous nous notifierez la rétractation du Contrat de restitution.
      </p>
      <h3>6. Durée</h3>
      <p>
        6.1. Le Contrat de fourniture et/ou de restitution est conclu pour une durée déterminée ou indéterminée. Les CP mentionnent si votre
        Contrat de fourniture et/ou de restitution est à durée déterminée ou indéterminée.
      </p>
      <p>
        6.2. Si votre Contrat de fourniture et/ou de restitution est à durée déterminée, il sera en principe automatiquement prolongé pour
        la durée mentionnée dans les CP, sauf indication contraire dans les CP. Nous pouvons vous informer au moins deux mois avant
        l’échéance de la durée en cours que nous ne souhaitons pas prolonger le Contrat de fourniture et/ou de restitution. Nous pouvons
        toutefois, à cette occasion, vous faire parvenir une nouvelle proposition de contrat de fourniture et/ou de restitution. Vous pouvez
        également renoncer vous-même à la prolongation en nous en informant par écrit (par courrier ou par e-mail) au moins un mois avant
        l’échéance de la durée en cours.
      </p>
      <p>
        6.3. Vous pouvez à tout moment résilier votre Contrat de fourniture et/ou de restitution gratuitement par écrit (par courrier ou par
        e-mail) moyennant un préavis d’au moins un mois. La fermeture du Point de fourniture ou la notification de la modification de
        fournisseur via le Gestionnaire de réseau est considérée, pour ce Point de fourniture, comme résiliation du Contrat de fourniture
        et/ou de restitution par vous-même.
      </p>
      <p>
        6.4. Nous pouvons résilier le Contrat de fourniture et/ou de restitution à durée indéterminée à tout moment moyennant un préavis de
        deux mois.
      </p>
      <p>
        6.5. Le Contrat de fourniture est dans les tous cas maintenu tant que Bolt est mentionné dans le registre d’accès en tant que
        responsable de l'approvisionnement de votre Point de fourniture.
      </p>
      <h3>7. Consommation, fourniture et mesures</h3>
      <p>7.1. Consommation</p>
      <p>
        7.1.1. Vous consommerez l’électricité et/ou le gaz naturel uniquement au Point de fourniture et vous vous abstiendrez de les fournir
        à des tiers.
      </p>
      <p>
        7.1.2. Si vous utilisez des appareils pour produire vous-même de l’énergie, vous êtes tenu de nous le signaler sans délai. Si vous
        le souhaitez, vous pouvez conclure un Contrat de restitution avec Bolt pour l’électricité injectée par vous dans le réseau.
      </p>
      <p>7.2. Fourniture et Gestionnaire de réseau</p>
      <p>
        7.2.1. Vous concluez avec nous le Contrat de fourniture et/ou le Contrat de restitution. Votre raccordement au réseau est géré par
        le Gestionnaire de réseau. Le Gestionnaire de réseau est responsable du fonctionnement du réseau ainsi que de la continuité de la
        Fourniture et la Restitution, il règle la qualité du prélèvement, l’arrivée d’électricité et/ou de gaz naturel, l’équipement de
        mesure et les dispositions techniques pertinentes pour le raccordement des installations ainsi que le raccordement et la fermeture
        de compteurs. Nous ne sommes pas partie à cette relation et ne sommes dès lors pas responsables du respect des règles applicables à
        cette relation par vous-même ou par le Gestionnaire de réseau.
      </p>
      <p>
        7.2.2. Si le Gestionnaire de réseau limite ou interrompt l’arrivée d’électricité et/ou de gaz naturel et/ou l'injection
        d’électricité dans le réseau, la Fourniture et/ou la Restitution sera également automatiquement limitée ou interrompue. Cette
        limitation et/ou interruption ne relève pas de notre responsabilité.
      </p>
      <p>7.3. Mesures</p>
      <p>
        7.3.1. Le Gestionnaire de réseau nous communique le relevé de votre compteur. Si vous nous communiquez le relevé, vous êtes
        responsable de son indication correcte. Dans tous les cas, les données du Gestionnaire du réseau ont la priorité.
      </p>
      <p>
        7.3.2. Tant vous que nous pouvons, en cas de doute quant à l’exactitude du relevé, faire examiner l'installation de mesure. Cette
        opération est effectuée aux frais du demandeur.
      </p>
      <p>
        7.3.3. Une rectification des mesures et de la facturation en résultant peut concerner une période de deux ans au maximum avant le
        dernier relevé, sauf stipulation contraire de la loi.
      </p>
      <h3>8. Prix et frais</h3>
      <p>
        8.1. Le prix dont vous êtes redevable à l'égard de Bolt pour la Fourniture comprend (1) le prix de l’énergie tel que déterminé dans
        les CP et (2) les autres éléments constitutifs du prix prescrits par l'article 8.2.
      </p>
      <p>8.2. Sauf stipulation contraire dans les CP, le prix de l'énergie est majoré de :</p>
      <ul>
        <li>
          la TVA, les taxes, redevances, cotisations, suppléments, indemnités et autres charges éventuelles qui nous sont imposés par les
          autorités ou instances de régulation compétentes ;
        </li>
        <li>
          les tarifs nets, les frais de location de compteur, les frais de raccordement ou de fermeture du Point de fourniture, les services
          de réseau supplémentaires éventuels, la puissance réactive et la puissance de pointe qui nous sont imposés par le Gestionnaire de
          réseau.
        </li>
        <li>
          Les frais résultant des obligations légales de produire des certificats verts, chaleur verte, cogénération et/ou des certificats
          analogues.
        </li>
      </ul>
      <p>
        Ces éléments constitutifs, y compris les modifications qui n'incombent pas à Bolt, vous sont facturé directement, et ce, avec effet
        rétroactif.
      </p>
      <p>
        8.3. Nous pouvons vous facturer tous les frais qui nous sont facturés par le Gestionnaire de réseau pour des services effectués à
        votre demande, à l’initiative du Gestionnaire de réseau ou à notre demande suite à une faute ou une négligence de votre part. Nous
        pouvons également vous facturer nos frais administratifs en plus de ces frais.
      </p>
      <p>8.4. Le montant que Bolt vous doit pour la Restitution est déterminé dans les CP.</p>
      <h3>9. Facturation et conditions de paiement</h3>
      <p>
        9.1. Nous nous appuyons, conformément à l’article 7.3, sur les relevés mis à notre disposition et sur les profils de consommation
        communiqués par le Gestionnaire de réseau, pour facturer vos prélèvements d’électricité et/ou de gaz naturel. Nous vous envoyons des
        factures d’acompte mensuelles. Nous fixons le montant de ces factures d’acompte sur la base des données que vous nous communiquez ou
        sur la base du décompte périodique, étant entendu que vous pouvez nous demander la révision du montant des factures d’acompte. Dans
        ce cas, nous vous indiquerons dans un délai raisonnable si nous pouvons donner suite à votre demande. Dans la mesure où nous avons
        reçu vos données de mesure du Gestionnaire de réseau, nous vous transmettons chaque année une facture dans laquelle nous portons en
        compte votre consommation effective et tenons compte des acomptes déjà facturés jusqu’au relevé des index. Si nous ne recevons pas
        de relevés du Gestionnaire de réseau, nous pouvons continuer à vous envoyer des factures d’acompte. Si nous recevons une
        consommation estimée du Gestionnaire de réseau, nous vous facturerons cette consommation estimée. Si nous constatons que les relevés
        sont erronés, nous le signalerons au Gestionnaire de réseau et nous continuerons à vous adresser des factures d’acompte. Nous
        procéderons ultérieurement à un décompte de votre consommation effective.
      </p>
      <p>
        9.2. Nos factures peuvent uniquement être payées sur notre compte bancaire, dont le numéro est indiqué sur la facture. Vous devez
        payer nos factures au plus tard dans les 15 jours calendrier à compter de leur date de réception (si la facture est envoyée par
        courrier postal, il s’agit du troisième jour après l’envoi). A défaut de paiement dans les délais, nous vous enverrons au moins un
        rappel. Si vous ne payez pas à temps suite à ce rappel, nous vous enverrons une mise en demeure.
      </p>
      <p>Si nous vous devons un montant, nous vous le rembourserons dans le délai de paiement susmentionné, sauf si :</p>
      <ol type="a">
        <li>
          nous ne connaissons pas votre numéro de compte (auquel cas nous procéderons au paiement/remboursement dans les 15 jours calendrier
          suivant la communication de votre numéro de compte) ; ou
        </li>
        <li>
          vous avez encore des factures impayées, ce qui nous donne le droit de récupérer les montants impayés conformément à la
          réglementation existante.
        </li>
      </ol>
      <p>
        Aucun coût supplémentaire n’est porté en compte au client qui refuse une domiciliation. Vous avez la possibilité d’exclure vos
        factures de décompte et de clôture de votre domiciliation. L’exécution du mandat de domiciliation relative à la facture de clôture
        se fera au plus tôt 15 jours calendrier après la date de réception de la facture de clôture (la date de réception étant le 3e jour
        après l’envoi de la facture si elle a été envoyée par courrier postal et le jour même si elle a été envoyée par e-mail).
      </p>
      <p>
        9.3. L’éventuel redevance que Bolt vous doit pour l’électricité que vous avez injectée sera déduite dans nos factures d’acompte et
        de clôture que vous devez à Bolt pour la fourniture de l’électricité que vous avez consommée. Vous payez le solde à Bolt ou Bolt
        vous paye le solde, selon le cas.
      </p>
      <p>
        9.4. Si vous ou nous pensons que notre facture comporte des données erronées (autres que les relevés), l’autre partie doit être
        contactée par écrit dans les 12 mois de la réception de la facture, sauf si un délai plus long est prévu par la réglementation en
        vigueur. Si la contestation d’une facture impayée est justifiée ou que celle-ci doit faire l’objet d’un examen plus approfondi, vous
        pouvez suspendre le paiement de la partie contestée de la facture jusqu’au moment où le traitement de la plainte est finalisé. Nous
        vous répondrons le plus rapidement possible après réception de la plainte (ou dès que possible après réception par un tiers des
        informations dont nous avons besoin pour répondre à la plainte).
      </p>
      <p>
        9.5. Le retard de paiement d’une facture a pour effet que toute autre facture, même si nous avons accepté un plan de paiement pour
        celle-ci, devient immédiatement exigible, sans mise en demeure.
      </p>
      <p>
        9.6. Dans la mesure autorisée et conformément à la législation en vigueur, nous pouvons imputer des frais administratifs pour
        l’envoi de factures supplémentaires, de duplicata, d’un plan de remboursement, de lettres suite à votre retard de paiement ou si la
        présentation d’une domiciliation est refusée par la banque et/ou la poste. Le coût s’élève à 8 EUR pour une lettre de rappel et à 20
        EUR pour une mise en demeure, sauf si la réglementation en vigueur prévoit d’autres montants.
      </p>
      <p>
        9.7. En cas de retard de paiement de la totalité ou d’une partie de la facture, ou si la présentation d'une domiciliation est
        refusée par l’institution financière, vous êtes tenu, de plein droit et sans mise en demeure ou rappel, au paiement d’intérêts de
        retard. Les intérêts de retard sont calculés au taux d’intérêt légal si vous êtes un Consommateur et au taux d'intérêt tel que prévu
        dans la loi concernant la lutte contre le retard de paiement dans les transactions commerciales d'août 2002 si vous êtes un Petit
        consommateur professionnel. Les intérêts de retard sont imputés à compter de l'échéance, sur tout montant impayé, jusqu'à la date du
        paiement intégral. En outre, en l’absence de paiement intégral après transmission de votre(vos) facture(s) impayée(s) à un tiers
        (p.ex. huissier de justice, avocat ou agence de recouvrement), vous êtes tenu de plein droit et sans autre mise en demeure au
        paiement d’un dédommagement forfaitaire égal à 10 % de toute facture impayée, avec un minimum de 55 EUR, en compensation des frais
        de recouvrement extrajudiciaires, conformément à la réglementation en vigueur, sans préjudice de notre droit de prouver plusieurs
        dommages, notamment par l’imputation de frais de procédure.
      </p>
      <p>
        9.8. Sauf si la réglementation régionale prévoit un autre dédommagement, vous avez droit à des intérêts de retard au taux d’intérêt
        légal sur tout montant impayé en cas d’erreur de facturation ou de retard de paiement/remboursement dans notre chef. Ces intérêts
        commencent à courir le lendemain du jour où nous aurions dû procéder au paiement conformément à l’article 9.2, ou, en cas d’erreur
        de facturation dans notre chef, à partir de la date de protestation de votre part, jusqu'à la date de paiement complet de notre
        part. Les coûts de vos mises en demeure et de vos rappels seront également à notre charge. En outre, vous avez droit à un
        dédommagement forfaitaire égal à 10 % du montant impayé pour autant que vous deviez faire appel à un tiers (p.ex. huissier de
        justice, avocat ou agence de recouvrement) pour en obtenir le paiement, avec un minimum de 55 EUR, et ce, en compensation des frais
        de recouvrement extrajudiciaires, conformément à la réglementation en vigueur, sans préjudice de votre droit de prouver plusieurs
        dommages, notamment par l’imputation de frais de procédure.
      </p>
      <p>9.9. Si le Contrat de fourniture est résilié, pour quelque raison que ce soit, nous vous transmettons un décompte final.</p>
      <p>
        9.10. Si vous estimez avoir droit au statut de client protégé ou au tarif social, et que cela ne se fait pas automatiquement, vous
        devez nous transmettre le plus vite possible les attestations et pièces justificatives nécessaires.
      </p>
      <h3>10. Responsabilité</h3>
      <p>
        10.1. Sans préjudice des autres dispositions en matière de responsabilité dans le présent Contrat de fourniture et/ou de restitution
        ou dans d’autres dispositions légales, vous et nous ne sommes responsables l’un envers l’autre qu’en cas : (a) d’inexécution des
        principaux engagements du Contrat de fourniture, et/ou de restitution sauf en cas de force majeure ; (b) de fraude, faute grave ou
        intentionnelle ; (c) de décès ou blessure corporelle vous concernant par un acte ou une négligence de la part de Bolt.
      </p>
      <p>
        10.2. En cas de responsabilité, seuls les dommages matériels directs seront indemnisés. Toute indemnisation de dommages immatériels,
        tels que les dommages d’exploitation, la perte de bénéfices, de production, de données ou de revenus, est expressément exclue. La
        réparation de tout dommage matériel ne pourra en outre pas excéder 12 fois votre consommation mensuelle moyenne des six derniers
        mois, ou de la durée du Contrat de fourniture et/ou de restitution si celle-ci est plus courte. Cette limitation n'est pas
        d'application en cas de décès ou de blessure corporelle vous concernant causé par un acte ou une négligence de la part de Bolt.
      </p>
      <p>
        10.3. Toute demande de dommages et intérêts doit être notifiée à l’autre partie, par écrit, dans les 30 jours calendrier à compter
        de la date de la survenance du dommage ou de la date où le dommage aurait raisonnablement pu être constaté. Les déclarations
        tardives de dommages ne sont pas indemnisées.
      </p>
      <p>
        10.4. Nous ne sommes pas responsables des dommages causés par le mauvais fonctionnement du réseau, des installations au Point de
        fourniture, de l’équipement de mesure, des relevés erronés, des variations de tension et de fréquence, des manquements dans le chef
        du Gestionnaire de réseau, ni des conséquences du non-respect des accords entre vous-même et le Gestionnaire de réseau. Nous ne
        sommes pas non plus responsables de la qualité des données échangées (comme, par exemple, les consommations annuelles standard, les
        profils synthétiques de charge). Tout cela relève de la responsabilité du Gestionnaire de réseau et est indépendant du Contrat de
        fourniture et/ou de restitution.
      </p>
      <p>10.5. Vous nous garantirez contre les actions éventuelles de tiers, notamment vos relations commerciales.</p>
      <h3>
        11. Suspension de la Fourniture et/ou de Restitution et résiliation immédiate du Contrat de fourniture et/ou du Contrat de
        restitution
      </h3>
      <p>
        11.1. En cas de manquement grave de notre part, vous pouvez résilier le Contrat de fourniture et/ou de restitution avant son terme
        par lettre recommandée, avec effet immédiat et sans intervention judiciaire.
      </p>
      <p>
        11.2. Nous pouvons suspendre la Fourniture et/ou la Restitutoin ou résilier le Contrat de fourniture et/ou de restitution avant son
        terme, par lettre recommandée, avec effet immédiat, sans intervention judiciaire ni indemnité, moyennant le respect de la
        réglementation en vigueur, si :
      </p>
      <ol type="a">
        <li>vous ne respectez pas vos obligations de paiement ou d’autres obligations après mise en demeure ;</li>
        <li>
          nous vous demandons de constituer une garantie conformément à l’article 4.3 et vous ne constituez pas cette garantie (dans les
          temps) ;
        </li>
        <li>
          une interruption ou un arrêt de la Fourniture et/ou la Restitution est imposé par le Gestionnaire de réseau ou par une autorité
          compétente ;
        </li>
        <li>vous fraudez ou livrez à des tiers de l’électricité et/ou du gaz naturel que nous avons livré(e) ;</li>
        <li>
          vous vous abstenez de nous informer immédiatement de tout élément dont vous avez connaissance et qui serait susceptible de gêner
          ou d’entraver l’exécution du Contrat de fourniture et/ou de restitution.
        </li>
      </ol>
      <p>
        La résiliation s’opère sans préjudice de notre droit à des dommages et intérêts. En cas de résiliation conformément à l’article 11.2
        (d), ce dédommagement sera au moins égal à la valeur estimée de trois mois de consommation. Si notre dommage est plus élevé, nous
        pourrons aussi le répercuter. Sans préjudice des dispositions des articles 9.5 et 9.6, vous ne serez toutefois pas redevable d'une
        quelconque indemnité si nous résilions le Contrat de fourniture sur la base de l’article 11.2 (a), (b) ou (c). (a), (b) ou (c).
      </p>
      <p>
        11.3. En cas de résiliation du Contrat de fourniture avant son terme par vous ou par nous, le Contrat de fourniture est toujours
        résilié dans son intégralité, autrement dit, aussi bien pour l'électricité que pour le gaz naturel. Le cas échéant, un nouveau
        Contrat de fourniture d'électricité ou de gaz naturel pourra être conclu ultérieurement.
      </p>
      <p>
        11.4. Quand le Contrat de restitution est résilié, prématurément ou non, par vous ou par nous, cela n’a aucune incidence sur le
        Contrat de fourniture, sauf indication contraire de votre part ou de la nôtre. Quand le Contrat de restitution est résilié, que ce
        soit prématurément ou non, par vous ou par nous, le Contrat de fourniture est également résilié.
      </p>
      <p>
        11.5. Le Contrat de fourniture est dans les tous cas maintenu tant que Bolt est mentionné dans le registre d’accès en tant que
        responsable de l'approvisionnement de votre Point de fourniture.
      </p>
      <p>12. Déménagement / cession</p>
      <p>
        12.1. En cas de déménagement, le Contrat de fourniture reste entièrement d’application à votre nouvelle adresse. Vous devez nous
        informer de vos projets de déménagement de préférence 30 jours calendrier au préalable (au plus tard 30 jours calendrier après le
        déménagement pour les Consommateurs et 10 jours calendrier après le déménagement pour les Petits consommateurs professionnels) et
        nous communiquer les informations suivantes :
      </p>
      <ol type="a">
        <li>votre future adresse ;</li>
        <li>le(s) code(s) EAN et le numéro de compteur à cette adresse ;</li>
        <li>
          la date à partir de laquelle il convient de fournir au nouveau Point de fourniture et d’arrêter la Fourniture au Point de
          fourniture actuel ; et tous les relevés de compteur de votre ancienne et de votre nouvelle adresse au moment du déménagement.
        </li>
      </ol>
      <p>
        Vous pouvez à cet effet utiliser les canaux de communication que nous mettons à disposition en vue du déménagement, notamment notre
        document de reprise des énergies.
      </p>
      <p>
        Si vous avez conclu un Contrat de restitution avec nous, il restera en vigueur à votre nouvelle adresse, sauf si vous nous informez
        que vous n’injecterez plus d’électricité à votre nouvelle adresse. Dans ce dernier cas, le Contrat de restitution sera résilié à la
        date du déménagement.
      </p>
      <p>
        12.2. Si nous ne sommes pas informés de votre déménagement dans le délai prévu à l'article 12.1, le Contrat de fourniture reste en
        vigueur pour votre ancienne adresse. Cela signifie que vous êtes tenu de payer l'électricité et/ou le gaz naturel prélevé(e) - par
        qui que ce soit - au Point de fourniture que vous quittez, sauf si la réglementation en vigueur prévoit un cadre contraire
        contraignant. Si nous ne sommes pas informés de votre déménagement dans le délai prévu à l'article 12.1, le Contrat de restitution
        prend fin au moment de votre déménagement. L’électricité qui est injectée - par quiconque - au Point de fourniture que vous quittez
        ne sera pas remboursée par Bolt, sauf disposition contraire dans la réglementation applicable.
      </p>
      <p>
        12.3. Nous vous envoyons une facture avec le décompte final pour le Point de fourniture que vous quittez. Si vous ne nous
        communiquez pas le relevé du Point de fourniture que vous quittez dans le délai prévu à l'article 12.1, nous avons dès lors le droit
        de faire relever le compteur par le Gestionnaire de réseau, à vos frais.
      </p>
      <p>
        12.4. Moyennant la production d’une attestation, le Contrat de fourniture peut être résilié, par vous ou par nous, à compter de la
        date de déménagement effective si vous déménagez à l’étranger ou vers une autre région, vers une habitation dans laquelle il n’y a
        pas de compteur séparé pour la consommation d'électricité et/ou de gaz naturel, si vous cohabitez avec un autre utilisateur qui a
        déjà un Contrat de fourniture et/ou de restitution (avec nous ou avec un autre fournisseur), ou encore si vous déménagez vers un
        territoire où nous ne sommes pas (plus) en mesure, pour des raisons objectives, de poursuivre le Contrat de fourniture et/ou de
        restitution.
      </p>
      <p>
        12.5. Nous fournirons l’énergie à votre nouveau Point de fourniture à partir de la date que vous nous aurez communiquée. Les CP du
        Contrat de fourniture et/ou de restitution peuvent être adaptées, ainsi qu’il est prévu à l’article 13 et/ou en fonction de votre
        nouveau Gestionnaire de réseau.
      </p>
      <p>
        12.6. Si vous ne respectez pas les obligations ci-dessus liées à votre déménagement, vous nous autorisez à demander, au gestionnaire
        de réseau, la fermeture du compteur du Point de fourniture que vous quittez. Dans ce cas, tous les frais de fermeture seront à votre
        charge. Nous ne sommes pas responsables des dommages causés dans ce cas.
      </p>
      <h3>13. Modifications du Contrat de fourniture et/ou du Contrat de restitution</h3>
      <p>
        13.1. Pour autant que ces modifications ne soient pas à votre désavantage, nous pouvons apporter des modifications au Contrat de
        fourniture et/ou de restitution à tout moment. Le cas échéant, nous vous communiquerons ces modifications de façon individualisée au
        moins deux mois avant leur entrée en vigueur. La notification par lettre, sur la facture, par e-mail ou sur tout autre support
        durable vaut communication.
      </p>
      <p>
        13.2. En outre, si votre Contrat de fourniture et/ou votre Contrat de restitution est à durée indéterminée, nous pouvons à tout
        moment :
      </p>
      <ul>
        <li>appliquer des augmentations de prix dans le cas d’un Contrat de fourniture ;</li>
        <li>réduire les frais de restitution dans le cas d’un Contrat de restitution ; ou</li>
        <li>apporter des changements à votre détriment.</li>
      </ul>
      <p>
        à condition que nous vous informions de ces changements au moins deux mois avant leur entrée en vigueur, de la même manière que
        celle prévue à l’article 13.1.
      </p>
      <p>
        Vous serez considéré comme ayant accepté ces modifications à moins que, dans le mois suivant la réception de la notification, vous
        ne résiliiez le Contrat de fourniture (dans le cas de modifications du contrat de fourniture) et/ou le Contrat de restitution (dans
        le cas de modifications du Contrat de restitution) conformément à l’article 6.3. En cas de communication par e-mail, le jour de
        réception est le jour de l’envoi de l’e-mail ; si la notification est envoyée par courrier postal, celui-ci sera réputé reçu le
        troisième jour après l'envoi.
      </p>
      <p>
        13.3. Si votre Contrat de fourniture est prolongé conformément à l’article 6.2, nous pouvons néanmoins vous proposer, deux mois
        avant la prolongation, de modifier les prix et/ou les conditions du Contrat de fourniture pour la période suivante. Si vous marquez
        par écrit votre accord sur les modifications, le Contrat de fourniture se poursuivra à ces conditions pour la période suivante. Si
        vous n’acceptez pas ces modifications et si vous n’avez pas changé de fournisseur à l'expiration de la période en cours, nous
        poursuivrons la fourniture aux prix et conditions de notre produit à durée déterminée équivalent le moins cher.
      </p>
      <p>
        13.4. Si votre Contrat de restitution est prolongé conformément à l’article 6.2, nous pouvons néanmoins vous proposer, deux mois
        avant la prolongation, de modifier les prix et/ou les conditions du Contrat de restitution pour la période suivante. Si vous marquez
        par écrit votre accord sur les modifications, le Contrat de fourniture se poursuivra à ces conditions pour la période suivante. Si
        vous ne le faites pas et que vous n’avez pas indiqué un autre fournisseur ou un tiers comme acheteur de l’électricité que vous avez
        injectée, Bolt a le choix de prolonger le Contrat de fourniture aux anciens prix et conditions, ou de ne pas le prolonger.
      </p>
      <p>
        13.5. Si, contrairement à ce qui est stipulé aux articles 13.1 et 13.2, les Conditions particulières sont modifiées en concertation
        avec nous, un nouveau Contrat de fourniture et/ou de restitution sera conclu dès que nous aurons intégré cette modification dans nos
        systèmes. Nous vous informerons de cette date.
      </p>
      <p>
        13.6. Nous pouvons céder le Contrat de fourniture et/ou de restitution à un tiers et nous vous en informerons dans ce cas. Ce tiers
        poursuivra la mise en œuvre du Contrat de fourniture et/ou de restitution aux mêmes conditions. Vous ne pouvez pas céder le Contrat
        de fourniture et/ou de restitution à un tiers, ni à un cohabitant, ni à un nouveau résident.
      </p>
      <h3>14. Modification du Producteur d'électricité</h3>
      <p>
        14.1. Le lien entre vous et le Producteur d'électricité est basé sur votre consommation moyenne et la production du Producteur
        d'électricité. Les fluctuations limitées dans votre consommation et la production du Producteur d'électricité seront absorbées par
        de l'électricité issue d'autres producteurs reliés à notre plateforme et produisant également de l'électricité locale et verte.
      </p>
      <p>
        14.2. Si le Producteur d'électricité n'est plus disponible sur notre plateforme ou s'il ne produit plus structurellement une
        quantité d'électricité suffisante pour satisfaire votre consommation d'électricité (en plus de celle des autres clients qui ont
        choisi ce Producteur d'électricité), Bolt vous en informera par écrit, soit par courrier, soit par e-mail. Nous vous proposerons un
        nouveau producteur pour remplacer votre Producteur d'électricité. Dès cette notification, vous disposez d'un mois pour nous
        proposer, par courrier ou par e-mail, un autre nouveau producteur. Ce délai d'un mois entre en vigueur à la date d'envoi de notre
        e-mail ou à partir du troisième jour après l'envoi de notre courrier. Si vous ne nous communiquez pas votre choix d'un autre nouveau
        producteur et que vous ne changez également pas de fournisseur dans ce délai, nous vous associerons au producteur que nous avons
        proposé.
      </p>
      <p>
        14.3. La modification du Producteur d'électricité conformément à l'article 14.2 ne sera pas considérée comme modification du Contrat
        de fourniture.
      </p>
      <h3>15. Responsabilité d’équilibre</h3>
      <p>Pour la responsabilité d’équilibre, tant pour la Fourniture que pour la Restitution, Bolt fait appel à [Luminus].</p>
      <h3>16. Force majeure</h3>
      <p>
        16.1. En cas de force majeure, les obligations découlant du présent Contrat de fourniture et/ou de restitution, à l’exception de
        l’obligation de paiement d’une somme d’argent, sont suspendues ou limitées pendant la période de force majeure. Par ‘force majeure’
        il y a lieu d’entendre : tout événement imprévisible et inévitable indépendant de la volonté d'une partie qui constitue un obstacle
        insurmontable pour le respect de l'engagement de cette partie, comme, mais sans s’y limiter, une panne du réseau, des problèmes au
        niveau du transport ou de la distribution, l’impossibilité d’obtenir de l’électricité ou du gaz naturel (en quantité suffisante),
        catastrophes naturelles, grèves.
      </p>
      <p>
        16.2. Si le Contrat de fourniture ne peut pas être exécuté pendant plus de trois mois en raison d’un cas de force majeure, aussi
        bien vous que nous avons le droit de résilier le Contrat de fourniture et/ou de restitution par écrit, sans qu’une indemnité ne soit
        due à l’autre partie.
      </p>
      <h3>17. Protection de la vie privée</h3>
      <p>
        En tant que responsable du traitement de vos données à caractère personnel, nous traitons toujours vos données à caractère personnel
        en conformité avec la réglementation applicable en matière de protection de la vie privée. Nous traitons vos données à caractère
        personnel aux fins et motifs décrits dans notre politique de confidentialité telle qu’elle figure sur notre site internet
        www.boltenergie.be à la rubrique « Mentions légales et Politique de confidentialité » (ci-après 'la Politique de confidentialité').
        En approuvant et acceptant expressément le Contrat de fourniture et/ou de restitution, vous confirmez avoir pris connaissance de la
        Politique de confidentialité et accepter le traitement de vos données à caractère personnel conformément à la Politique de
        confidentialité.
      </p>
      <h3>18. Absence d'abandon de droit</h3>
      <p>
        Le fait de ne pas poursuivre l’exécution d’une disposition quelconque du Contrat de fourniture et/ou de restitution ne peut être
        considéré comme un abandon ou une limitation de ce droit.
      </p>
      <h3>19. Dispositions nulles</h3>
      <p>
        La nullité ou l’invalidité d’une des dispositions du Contrat de fourniture et/ou de restitution n’aura pas d’incidence sur la
        validité des autres dispositions du Contrat de fourniture et/ou de restitution. Si une des dispositions est nulle ou non valable,
        cette disposition nulle ou non valable sera remplacée, autant que possible, par une disposition valable qui se rapprochera le plus
        possible de l’objectif initial des parties.
      </p>
      <h3>20. Droit applicable et litiges - plaintes</h3>
      <p>20.1. Le droit belge s’applique au Contrat de fourniture et/ou de restitution.</p>
      <p>
        20.2. En cas de plaintes, vous pouvez vous adresser à notre service clientèle, dont vous retrouvez les coordonnées sur votre facture
        ou sur notre website. Si votre Contrat de fourniture et/ou de restitution a été conclu en ligne, rendez-vous sur la plate-forme ODR
        pour faire des réclamations en ligne (<a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a>).
      </p>
      <p>
        20.3. Les litiges concernant le Contrat de fourniture et/ou de restitution peuvent être portés, au choix de la partie demanderesse,
        devant le juge du domicile de la partie défenderesse ou devant le juge du lieu où l'engagement auquel le litige se rapporte est
        survenu ou où il doit être exécuté.
      </p>
      <h3>MODÈLE DE FORMULAIRE DE RÉTRACTATION</h3>
      <p>
        Veuillez compléter et renvoyer le présent formulaire à Bolt uniquement si vous souhaitez vous rétracter du Contrat de fourniture
        et/ou de restitution.
      </p>
      <p>Veuillez renvoyer ce document à Bolt :</p>
      <p>Par courrier postal : (remplir l'adresse)</p>
      <p>Par e-mail : (remplir l'adresse mail)</p>
      <p>
        Je vous notifie par la présente ma rétractation du Contrat de fourniture portant sur la fourniture et/ou de restitution
        d'électricité / gaz*. (Biffer la mention inutile).
      </p>
      <p>Nom de produit :</p>
      <p>Date de confirmation du Contrat de fourniture et/ou de restitution :</p>
      <p>
        <i>
          Si le Contrat de fourniture et/ou de restitution a été conclu par téléphone : la date à laquelle vous avez confirmé la Contrat de
          fourniture et/ou de restitution.
        </i>
      </p>
      <p>
        <i>Dans tous les autres cas : la date à laquelle Bolt a confirmé le Contrat de fourniture et/ou de restitution.</i>
      </p>
      <p>Nom Consommateur :</p>
      <p>Adresse Consommateur :</p>
      <p>Date :</p>
      <p>Signature :</p>
    </>
  )
}

export default TermsFrench
